import React from 'react';
import PropTypes from 'prop-types';
import {notify} from 'react-notify-toast';

export default class Callout extends React.Component {
    componentDidMount() {
        notify.show(this.props.text, this.props.type);
    }

    render() {
        return null;
    }
}

Callout.propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['error', 'success', 'warning']).isRequired
};